<ng-container *ngIf="!(srvRpDesign.isMobile$ | async)">
  <div class="bg-white p-5">
    <div class="font-dialog-success-title d-flex justify-content-center" [ngStyle]="UIUtilityService.getHeaderStyle()">
      {{ data.title }}
    </div>

    <div class="text-center mt-5 mb-4">
      <img src="assets/images/icons/icon_check.png" width="75" class="mb-2" alt="Icon Check" />
    </div>

    <div class="mx-3 px-0 font-dialog-success-content" mat-dialog-content>
      <p *ngFor="let msg of message">{{ msg }}</p>
    </div>

    <mat-dialog-actions class="d-flex justify-content-center my-2" *ngIf="data.buttonText">
      <button mat-button (click)="success($event)" class="btn-lg py-4 px-4 px-sm-5 font-button button-action-base" cdkFocusInitial>
        {{ data.buttonText }}
      </button>
    </mat-dialog-actions>
  </div>
</ng-container>

<ng-container *ngIf="(srvRpDesign.isMobile$ | async)">
  <div class="bg-white py-4 px-3">
    <div class="mb-3 mobile-font-dialog-success-title d-flex justify-content-center" [ngStyle]="UIUtilityService.getHeaderStyle()">
      {{ data.title }}
    </div>

    <div class="text-center mb-2">
      <img src="assets/images/icons/icon_check.png" width="60" alt="Icon Check" />
    </div>

    <div class="p-0 mb-2 mobile-font-dialog-success-content" mat-dialog-content>
      <p *ngFor="let msg of message">{{ msg }}</p>
    </div>

    <mat-dialog-actions class="d-flex justify-content-center p-0" *ngIf="data.buttonText">
      <button mat-button (click)="success($event)" class="btn-lg py-4 px-4 px-sm-5 font-button button-action-base" cdkFocusInitial>
        {{ data.buttonText }}
      </button>
    </mat-dialog-actions>
  </div>
</ng-container>
